import { Column } from "components/Table/Simple";
import { formatDate, formatDateTime } from "components/Table/Simple/presets";

/*
id
created_at
updated_at
social_type
social_user_id
nickname
name
email
social_data
refresh_token
*/
export const columns: Column[] = [
    {
        field: "id",
        label: "ID",
        visible: true,
    },
    {
        field: "social_type",
        label: "SNS 타입",
        visible: true,
    },
    {
        field: "nickname",
        label: "닉네임",
        visible: true,
    },
    {
        field: "name",
        label: "이름",
        visible: true,
    },
    {
        field: "email",
        label: "이메일",
        visible: true,
    },
    {
        field: "created_at",
        label: "가입일",
        visible: true,
        render: formatDateTime
    },
    {
        field: "updated_at",
        label: "수정일",
        visible: true,
        render: formatDateTime
    },

    {
        field: "social_user_id",
        label: "소셜 ID",
        visible: false,
    },
    {
        field: "social_data",
        label: "소셜 데이터",
        visible: false,
    },
    {
        field: "refresh_token",
        label: "리프레시 토큰",
        visible: false,
    },
]